import Vue from 'vue'
import { baseDataService, reorder } from '@/services/mixins/itemDataServiceMixins'

export default new (Vue.extend({
	defaultPath: '/team/topics',
	mixins: [baseDataService, reorder],
}))()
